

































import {
	computed,
	defineComponent,
	PropType,
	Ref,
	ref,
} from '@vue/composition-api';
import addMinutes from 'date-fns/addMinutes';
import parse from 'date-fns/parse';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import GroupReportTable from '@front-app/views/csr/communityReports/GroupReportTable.vue';
import TrForm from '@front-app/components/form/Form.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { Size, Spacing } from '@front-app/components/constants';
import { toDatetimeLocal } from '@front-app/util/format';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import { v } from '@front-app/components/form/validation/useValidation';
import { required } from '@front-app/components/form/validation/validators';
import {
	REPORT_TYPE,
	CommunityReportRequest,
	GroupReportData,
	fetchCommunityReport,
} from '@front-app/services/CommunityApi/CommunityReportsApi';

export default defineComponent({
	components: {
		CtaButton,
		ErrorCard,
		GroupReportTable,
		TrForm,
	},
	props: {
		selectedGroups: {
			type: Array as PropType<string[]>,
			required: true,
		},
	},
	setup(props) {
		const reportData: Ref<GroupReportData[]> = ref([]);

		const validation = v({
			selectedGroups: {
				value: computed(() => props.selectedGroups),
				rules: [required()],
			},
		});

		const { focusFirstInvalid } = useFocusFirstInvalidField({
			containerSelector: '#group-report-form',
			scrollConfig: { block: 'center' },
		});

		const formatTime = (time: string) => parse(time, "yyyy-MM-dd'T'HH:mm", new Date()).toISOString();

		const reportStatus = useAsyncStatus();

		const runReport = async () => {
			validation.validate();
			if (!validation.isValid.value) {
				focusFirstInvalid();
				return;
			}

			const payload: CommunityReportRequest = {
				type: REPORT_TYPE.TOTAL_MEMBERS,
				groupIds: props.selectedGroups,
				startTime: formatTime(toDatetimeLocal(addMinutes(Date.now(), 10))),
				endTime: formatTime(toDatetimeLocal(addMinutes(Date.now(), 10))),
			};

			reportData.value = await reportStatus.track(fetchCommunityReport(payload));
		};

		return {
			validation,
			runReport,
			reportStatus,
			reportData,
			// Util
			ButtonPalettes,
			Size,
			Spacing,
		};
	},
});
